import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer min-h-16 bg-blog text-white flex flex-col items-center justify-center py-4 gap-3 border-t border-customPurple-premium/30">
      <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
        <Link
          to="/hukum-ve-kosullar"
          className="text-white/90 hover:text-customPurple-light transition-colors"
        >
          {t("legal.termsAndConditions")}
        </Link>
        <span className="text-white/40">|</span>
        <Link
          to="/gizlilik-sozlesmesi"
          className="text-white/90 hover:text-customPurple-light transition-colors"
        >
          {t("legal.privacyPolicy")}
        </Link>
      </div>
      <div className="footer-text text-center text-sm text-white/70">
        {t("footer.copyright", { year: currentYear })}
      </div>
    </footer>
  );
}

export default Footer;
